<template>
    <section v-if="basicData && isAction" :class="setTabFixed  ? 'fixed-bottom' : ''">
        <hr class="divider shadow">
        <div class="d-flex flex-row justify-content-between pdt-10 pdb-10 pdl-16 pdr-16 footer-wrapper" v-if="basicData.goods">
            <div class="t-headline5" v-if="basicData.goods.paymentPrice > 0">
                <span class="t-body3 unit">
                    {{basicData.goods.currency.key || 'USD'}}
                </span>
                {{$n(basicData.goods.paymentPrice)}}
            </div>
            <div class="t-headline5" v-else>
                {{$t('664')}}
                <!-- Free -->
            </div>

            <div v-for="(action, index) in basicData.actions" :key="index">
                <button class="mdc-button mdc-button--raised btn-red" 
                :disabled="!action.enable" 
                    @click="actionDegree(action)"
                >
                    {{
                        basicData.goods.paymentPrice > 0 ? 
                            $t(action.translate, {str : $moment(action.translateParams.registerStart).format('L')}) :
                            $t('button.online.degree.enter')
                    }}
                </button>
            </div>
        </div>
    </section>
</template>

<script>
/**
 * 차수 상세 푸터 컴포넌트(degree view footer component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import ViewHeader from './Header.vue'

export default {
    props: ['setTabFixed'],
    extends: ViewHeader,
    computed: {
       isAction() {
           return this.basicData.actions[0].enable
       }
    },
}
</script>